import getEnv from './getEnv'

const ACCOUNTS_DASHBOARD_URL = {
  local: 'http://accounts.internal:5140',
  dev: 'https://accounts.bejusto.com',
  prod: 'https://accounts.getjusto.com'
}

export default ACCOUNTS_DASHBOARD_URL[getEnv()]
